/* unplugin-vue-components disabled */import { render } from "./job.vue?vue&type=template&id=074fbf70&scoped=true"
import script from "./job.vue?vue&type=script&lang=js"
export * from "./job.vue?vue&type=script&lang=js"

import "./job.vue?vue&type=style&index=0&id=074fbf70&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074fbf70"],['__file',"src/components/cards-v2/persona/jobs/job.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "074fbf70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('074fbf70', __exports__)) {
    api.reload('074fbf70', __exports__)
  }
  
  module.hot.accept("./job.vue?vue&type=template&id=074fbf70&scoped=true", () => {
    api.rerender('074fbf70', render)
  })

}


export default __exports__